import { drawRoundedPolygon, fitToSize, inflatePolygon, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
/**
 * Represents an Extract shape, a flowchart element used to indicate extraction of data or a process step.
 * Extends the Rectangle class with a custom triangular path.
 */
export class Extract extends Rectangle {
    /**
     * @hidden
     * Draws the extract shape path as a triangle.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const r = this.options.cornerRadius || 0;
        const points = [
            { x: width / 2, y: 0 },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        const inflated = inflatePolygon(points, r);
        drawRoundedPolygon(drawingElement, inflated, r);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
